import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rv/rect.png'
import _imports_1 from '@/assets/images/rv/screen.png'
import _imports_2 from '@/assets/images/rv/arrow-down.svg'
import _imports_3 from '@/assets/images/copy-icon.svg'
import _imports_4 from '@/assets/images/date-icon.svg'
import _imports_5 from '@/assets/images/rv/arrow-blue.png'
import _imports_6 from '@/assets/images/rv/warning.svg'


const _withScopeId = n => (_pushScopeId("data-v-6e12e449"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content sicco-wrap" }
const _hoisted_2 = { class: "overview" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", null, "概览")
], -1))
const _hoisted_4 = { class: "bottom" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 零售月份：")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 零售提交截止日期：")
const _hoisted_7 = { class: "text-row" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("零售总计： ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("待审核： ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("修改待审核： ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("退车： ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 零售月份：")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 零售提交截止日期： ")
const _hoisted_14 = { class: "text-date" }
const _hoisted_15 = { class: "text-row" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("零售总计： ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("待审核： ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("修改待审核： ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("退车： ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createTextVNode(" 异常零售："),
  /*#__PURE__*/_createElementVNode("span", null, "缺失零售月份")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, "   ", -1))
const _hoisted_22 = { class: "text-row" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("零售总计： ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("待审核： ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("修改待审核： ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("退车： ")
const _hoisted_27 = { class: "condition-title" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "screen"
}, null, -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 批准 ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 拒绝 ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("批量下载文件")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("导出查询结果")
const _hoisted_33 = { style: {"padding-left":"16px"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "车架号", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "车型", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "经销商中文名称", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "零售日期", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, null, -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_42 = { style: {"margin-top":"8px"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "零售类型", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "激励适用性", -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode("更多 ")
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {"transform":"rotate(180deg)","margin-left":"4px"}
}, null, -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "生产编号", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "车型分类", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "年款", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "批发来源", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "特殊车辆用途", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "动力类型", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "品牌", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "经销商代码(Cofico)", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "经销商代码(SWT)", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "经销商英文名称", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "区域", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "发票日期", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "上牌日期", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" 收起")
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {"margin-left":"4px"}
}, null, -1))
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "提交状态", -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 收起 ")
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {"margin-left":"4px"}
}, null, -1))
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = { class: "table-box" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" 发票")
const _hoisted_72 = /*#__PURE__*/_createTextVNode("行驶证")
const _hoisted_73 = /*#__PURE__*/_createTextVNode("关系证明")
const _hoisted_74 = /*#__PURE__*/_createTextVNode("详细")
const _hoisted_75 = { class: "pagination-container d-f justify-e" }
const _hoisted_76 = { class: "batch-query-title" }
const _hoisted_77 = { style: {"padding":"0 8px"} }
const _hoisted_78 = { class: "list-title" }
const _hoisted_79 = { class: "list-content" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode("清除")
const _hoisted_81 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_82 = /*#__PURE__*/_createTextVNode("下载文件")
const _hoisted_83 = /*#__PURE__*/_createTextVNode("下载文件")
const _hoisted_84 = ["src"]
const _hoisted_85 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  width: "20",
  style: {"margin":"0 8px 0 -12px"}
}, null, -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"550","font-size":"16px"} }, "提示", -1))
const _hoisted_88 = { style: {"text-align":"center","margin":"0 32px","font-weight":"550","font-size":"16px"} }
const _hoisted_89 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_90 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  width: "20",
  style: {"margin":"0 8px 0 -12px"}
}, null, -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"550","font-size":"16px"} }, "提示", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","margin":"0 32px","font-weight":"550","font-size":"16px"} }, " 请先选择零售车辆信息再进行操作 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_brand_selector = _resolveComponent("brand-selector")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_movable_modal = _resolveComponent("movable-modal")!
  const _component_sicco_detail = _resolveComponent("sicco-detail")!
  const _component_a_textarea = _resolveComponent("a-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("section", null, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.overview.currRetailMonth), 1)
            ]),
            _createElementVNode("section", null, [
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(_ctx.overview.currRetailSubmitDate), 1)
            ]),
            _createElementVNode("section", _hoisted_7, [
              _createElementVNode("span", null, [
                _hoisted_8,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.overviewSerachEvent('leftRetialTotal')))
                }, _toDisplayString(_ctx.overview.currRetailTotal), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_9,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.overviewSerachEvent('leftUnAuditTotal')))
                }, _toDisplayString(_ctx.overview.currPreCheckTotal), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_10,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.overviewSerachEvent('leftModifyUnAuditTotal')))
                }, _toDisplayString(_ctx.overview.currMdfPreCheckTotal), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_11,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.overviewSerachEvent('leftCheckStatusReturnedCar')))
                }, _toDisplayString(_ctx.overview.currVinCountOfReturn), 1)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("section", null, [
              _hoisted_12,
              _createElementVNode("span", null, _toDisplayString(_ctx.overview.lastRetailMonth), 1)
            ]),
            _createElementVNode("section", null, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.overview.lastRetailSubmitDate), 1)
            ]),
            _createElementVNode("section", _hoisted_15, [
              _createElementVNode("span", null, [
                _hoisted_16,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.overviewSerachEvent('rightRetialTotal')))
                }, _toDisplayString(_ctx.overview.lastRetailTotal), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_17,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.overviewSerachEvent('rightUnAuditTotal')))
                }, _toDisplayString(_ctx.overview.lastPreCheckTotal), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_18,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.overviewSerachEvent('rightModifyUnAuditTotal')))
                }, _toDisplayString(_ctx.overview.lastMdfPreCheckTotal), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_19,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.overviewSerachEvent('rightCheckStatusReturnedCar')))
                }, _toDisplayString(_ctx.overview.lastVinCountOfReturn), 1)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_20,
            _hoisted_21,
            _createElementVNode("section", _hoisted_22, [
              _createElementVNode("span", null, [
                _hoisted_23,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.overviewSerachEvent('abnormalRetialTotal')))
                }, _toDisplayString(_ctx.overview.abnormalRetailTotal), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_24,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.overviewSerachEvent('abnormalUnAuditTotal')))
                }, _toDisplayString(_ctx.overview.abnormalPreCheckTotal), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_25,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.overviewSerachEvent('abnormalModifyUnAuditTotal')))
                }, _toDisplayString(_ctx.overview.abnormalMdfPreCheckTotal), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_26,
                _createElementVNode("strong", {
                  class: "text",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.overviewSerachEvent('abnormalCheckStatusReturnedCar')))
                }, _toDisplayString(_ctx.overview.abnormalVinCountOfReturn), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["condition", { 'open-condition': _ctx.isOpen }])
      }, [
        _createElementVNode("section", _hoisted_27, [
          _createElementVNode("div", null, [
            _hoisted_28,
            _createElementVNode("strong", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => {
              _ctx.isOpen = !_ctx.isOpen;
              _ctx.isOpenPanle = false;
            })
            }, "筛选条件"),
            _createElementVNode("img", {
              src: _imports_2,
              class: _normalizeClass(["arrow", { 'rotate-arrow': _ctx.isOpen }]),
              onClick: _cache[13] || (_cache[13] = ($event: any) => {
              _ctx.isOpen = !_ctx.isOpen;
              _ctx.isOpenPanle = false;
              _ctx.activeKey = '';
            })
            }, null, 2)
          ]),
          _createElementVNode("div", null, [
            (_ctx.$btnPermissions('RV0006'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  class: "button",
                  onClick: _ctx.approvalEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_29
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.$btnPermissions('RV0007'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  type: "primary",
                  class: "button",
                  onClick: _ctx.rejectModalEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, {
              class: "button",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleBatchDownload(_ctx.selectedRowKeys)))
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }),
            (_ctx.$btnPermissions('RV0008'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 2,
                  class: "button",
                  onClick: _ctx.exportResult
                }, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("section", {
          class: _normalizeClass(["condition-content clearfix", { 'open-condition-content': _ctx.isOpen }])
        }, [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_a_space, {
              style: {"display":"flex","justify-content":"space-between"},
              align: "start"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withCtx(() => [
                      _hoisted_34,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.vinNo,
                            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.vinNo) = $event)),
                            placeholder: "请输入",
                            maxlength: 17,
                            style: {"width":"200px"}
                          }, null, 8, ["value"]),
                          _createElementVNode("img", {
                            class: "batch-query",
                            src: _imports_3,
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.batchQueryEvent('vinNo')))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-right":"8px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_35,
                      _createVNode(_component_a_input, {
                        value: _ctx.model,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.model) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-right":"8px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_36,
                      _createVNode(_component_a_auto_complete, {
                        value: _ctx.dealerNameCn,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dealerNameCn) = $event)),
                        options: _ctx.dealerNameCnArray,
                        onSearch: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSearch($event, 'C'))),
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withCtx(() => [
                      _hoisted_37,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_range_picker, {
                            style: {"width":"250px","margin-right":"8px"},
                            value: [_ctx.retailStartDate, _ctx.retailEndDate],
                            placeholder: ['开始时间', '结束时间'],
                            valueFormat: "YYYY/MM/DD",
                            onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.dateChangeEvent($event, 'retail'))),
                            format: "YYYY/MM/DD"
                          }, {
                            suffixIcon: _withCtx(() => [
                              _hoisted_38
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withCtx(() => [
                      _hoisted_39,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            style: {"margin-right":"8px"},
                            onClick: _ctx.mulSearchEvent
                          }, {
                            default: _withCtx(() => [
                              _hoisted_40
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_a_button, {
                            class: "button",
                            onClick: _ctx.resetEvent
                          }, {
                            default: _withCtx(() => [
                              _hoisted_41
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_a_space, {
                direction: "vertical",
                style: {"margin-right":"8px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_43,
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.usage,
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.usage) = $event)),
                        placeholder: "请选择",
                        allowClear: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageArray, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              value: item,
                              key: item
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_space, { direction: "vertical" }, {
                default: _withCtx(() => [
                  _hoisted_44,
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.checkStatus,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.checkStatus) = $event)),
                        placeholder: "请选择",
                        allowClear: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkStatusArray, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              value: item.code,
                              key: item.code
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.msg), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _withDirectives(_createElementVNode("span", {
                        class: "more",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => {
                    _ctx.isOpenPanle = true;
                    _ctx.showCollapsed = false;
                  })
                      }, _hoisted_47, 512), [
                        [_vShow, !_ctx.isOpenPanle]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ], 2),
        _createElementVNode("section", {
          class: _normalizeClass(["condition-content-panle clearfix", { 'open-content-condition-panle': _ctx.isOpenPanle }])
        }, [
          _createVNode(_component_a_collapse, {
            activeKey: _ctx.activeKey,
            "onUpdate:activeKey": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.activeKey) = $event)),
            style: {"padding-left":"16px"},
            onChange: _ctx.handleActiveKey
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_collapse_panel, {
                key: "1",
                header: "车辆类别"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_48,
                          _createVNode(_component_a_space, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                placeholder: "请输入",
                                value: _ctx.commissionNo,
                                "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.commissionNo) = $event))
                              }, null, 8, ["value"]),
                              _createElementVNode("img", {
                                class: "batch-query",
                                src: _imports_3,
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.batchQueryEvent('commissionNo')))
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_49,
                          _createVNode(_component_a_select, {
                            value: _ctx.typeClass,
                            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.typeClass) = $event)),
                            "show-search": true,
                            "option-filter-prop": "title",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeClassArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item.code,
                                  title: item.msg,
                                  key: item.code
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.msg), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "title"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_50,
                          _createVNode(_component_a_select, {
                            placeholder: "请选择",
                            value: _ctx.modelYear,
                            "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.modelYear) = $event)),
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelYearArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item.code,
                                  key: item.code
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.msg), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_51,
                          _createVNode(_component_a_select, {
                            placeholder: "请选择",
                            value: _ctx.entity,
                            "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.entity) = $event)),
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item,
                                  key: item
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_52,
                          _createVNode(_component_a_select, {
                            placeholder: "请选择",
                            value: _ctx.specialUsage,
                            "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.specialUsage) = $event)),
                            allowClear: "",
                            style: {"width":"170px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialUsageArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item,
                                  key: item
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_53,
                          _createVNode(_component_a_select, {
                            placeholder: "请选择",
                            value: _ctx.powerTrain,
                            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.powerTrain) = $event)),
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.powerTrainArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item.code,
                                  key: item.code
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.msg), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_54,
                          _createVNode(_component_a_space, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_brand_selector, {
                                value: _ctx.brand,
                                "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.brand) = $event)),
                                "data-loaded": "handleBrandsLoaded",
                                allowClear: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_collapse_panel, {
                key: "2",
                header: "经销商类别"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withCtx(() => [
                      _hoisted_55,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_auto_complete, {
                            value: _ctx.dealerCofficoCode,
                            "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.dealerCofficoCode) = $event)),
                            options: _ctx.coficoArray,
                            onSearch: _cache[33] || (_cache[33] = ($event: any) => (_ctx.handleSearch($event, 'D'))),
                            allowClear: ""
                          }, null, 8, ["value", "options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-left":"16px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_56,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_auto_complete, {
                            value: _ctx.dealerSwtCode,
                            "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.dealerSwtCode) = $event)),
                            options: _ctx.swtArray,
                            onSearch: _cache[35] || (_cache[35] = ($event: any) => (_ctx.handleSearch($event, 'S'))),
                            allowClear: ""
                          }, null, 8, ["value", "options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-left":"16px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_57,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_auto_complete, {
                            value: _ctx.dealerNameEn,
                            "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.dealerNameEn) = $event)),
                            options: _ctx.dealerNameEnArray,
                            onSearch: _cache[37] || (_cache[37] = ($event: any) => (_ctx.handleSearch($event, 'E'))),
                            allowClear: ""
                          }, null, 8, ["value", "options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-left":"16px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_58,
                      _createVNode(_component_a_select, {
                        allowClear: "",
                        placeholder: "请选择",
                        style: {"width":"170px"},
                        value: _ctx.region,
                        "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.region) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areasArray, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.code,
                              value: item.code
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.msg), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_collapse_panel, {
                key: "3",
                header: "日期类别"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withCtx(() => [
                      _hoisted_59,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_range_picker, {
                            style: {"width":"250px","margin-right":"8px"},
                            value: [_ctx.invoiceStartDate, _ctx.invoiceEndDate],
                            placeholder: ['开始时间', '结束时间'],
                            valueFormat: "YYYY/MM/DD",
                            onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.dateChangeEvent($event, 'invoice'))),
                            format: "YYYY/MM/DD"
                          }, {
                            suffixIcon: _withCtx(() => [
                              _hoisted_60
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-left":"16px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_61,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_range_picker, {
                            style: {"width":"250px","margin-right":"8px"},
                            value: [_ctx.licenseStartDate, _ctx.licenseEndDate],
                            placeholder: ['开始时间', '结束时间'],
                            valueFormat: "YYYY/MM/DD",
                            onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.dateChangeEvent($event, 'license'))),
                            format: "YYYY/MM/DD"
                          }, {
                            suffixIcon: _withCtx(() => [
                              _hoisted_62
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_collapse_panel, {
                key: "4",
                header: "审核结果类别"
              }, {
                extra: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", {
                    onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
                    class: "show-collapsed"
                  }, _hoisted_65, 512), [
                    [_vShow, !_ctx.showCollapsed]
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-bottom":"20px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_66,
                      _createVNode(_component_a_select, {
                        allowClear: "",
                        placeholder: "请选择",
                        value: _ctx.approlStatus,
                        "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.approlStatus) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvalStatusArray, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              value: item.code,
                              key: item.code
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.msg), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("div", {
                    onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
                    class: "show-collapsed",
                    style: {"float":"right","margin-top":"50px","margin-right":"10px","cursor":"pointer"}
                  }, _hoisted_69, 512), [
                    [_vShow, _ctx.showCollapsed]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeKey", "onChange"])
        ], 2)
      ], 2),
      _createElementVNode("div", _hoisted_70, [
        _createVNode(_component_a_table, {
          "row-selection": {
          selectedRowKeys: _ctx.selectedRowKeys,
          onChange: _ctx.onSelectChange
        },
          columns: _ctx.columns,
          "data-source": _ctx.tableData,
          scroll: { x: _ctx.tableWidth, y: _ctx.tableHeight },
          pagination: false,
          rowKey: "id",
          rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
        }, {
          approlStatus: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_ctx.EnumApprovalStatus[record.approlStatus]), 1)
          ]),
          checkStatus: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(record.checkStatus === '' ? '无' : _ctx.EnumCheckStatus[record.checkStatus]), 1)
          ]),
          file: _withCtx(({ record }) => [
            (_ctx.$btnPermissions('RV0009'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "link",
                  onClick: ($event: any) => (_ctx.invoiceEvent(record.vinNo, record.dealerCode)),
                  disabled: record.invoicePath === ''
                }, {
                  default: _withCtx(() => [
                    _hoisted_71
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled"]))
              : _createCommentVNode("", true),
            (record.usage !== '最终用户用车')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_a_divider, { type: "vertical" }),
                  (_ctx.$btnPermissions('RV0009') && record.usage !== '最终用户用车')
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "link",
                        onClick: ($event: any) => (_ctx.licenseEvent(record.vinNo, record.dealerCode)),
                        disabled: record.licensePath === ''
                      }, {
                        default: _withCtx(() => [
                          _hoisted_72
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_divider, { type: "vertical" }),
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.relationProofEvent(record.vinNo, record.dealerCode)),
                    disabled: record.relationProofPath === ''
                  }, {
                    default: _withCtx(() => [
                      _hoisted_73
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          action: _withCtx(({ record }) => [
            (_ctx.$btnPermissions('RV0010'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "link",
                  onClick: ($event: any) => (_ctx.detailEvent(record))
                }, {
                  default: _withCtx(() => [
                    _hoisted_74
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["row-selection", "columns", "data-source", "scroll", "rowClassName"])
      ])
    ]),
    _createElementVNode("div", _hoisted_75, [
      _createVNode(_component_a_pagination, {
        total: _ctx.total,
        "show-size-changer": "",
        "show-total": (total) => `共 ${total} 条`,
        onChange: _ctx.pageChange,
        onShowSizeChange: _ctx.sizeChange,
        pageSize: _ctx.size,
        "onUpdate:pageSize": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.size) = $event)),
        current: _ctx.current,
        "onUpdate:current": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.current) = $event)),
        pageSizeOptions: ['10', '20', '30', '40', '50']
      }, {
        buildOptionText: _withCtx((props) => [
          _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
        ]),
        _: 1
      }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "pageSize", "current"])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.batchQueryModal,
      "onUpdate:visible": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.batchQueryModal) = $event)),
      width: 420,
      onCancel: _ctx.closeBatchQueryModal,
      class: "batch-query-modal",
      centered: ""
    }, {
      title: _withCtx(() => [
        _createElementVNode("strong", _hoisted_76, _toDisplayString(_ctx.batchQueryTitle), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          size: "small",
          onClick: _ctx.clearBatchQuery
        }, {
          default: _withCtx(() => [
            _hoisted_80
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          size: "small",
          type: "primary",
          onClick: _ctx.closeBatchQueryModal
        }, {
          default: _withCtx(() => [
            _hoisted_81
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("article", null, [
            _createElementVNode("section", _hoisted_78, _toDisplayString(_ctx.batchQueryListTitle), 1),
            _createElementVNode("section", _hoisted_79, [
              (_ctx.textNoArray.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.textNoArray, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "list-item",
                      key: index
                    }, _toDisplayString(item), 1))
                  }), 128))
                : _createCommentVNode("", true),
              _createVNode(_component_a_input, {
                ref: "input",
                value: _ctx.textContentNo,
                "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.textContentNo) = $event)),
                onChange: _ctx.textChangEvent,
                style: {"height":"24px"}
              }, null, 8, ["value", "onChange"]),
              (_ctx.batchPlaceholder.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.batchPlaceholder, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "list-item",
                      style: {"height":"24px","margin-top":"8px"}
                    }))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onCancel"]),
    (!_ctx.pdf)
      ? (_openBlock(), _createBlock(_component_movable_modal, {
          key: 0,
          visible: _ctx.pictureModalFlag,
          "onUpdate:visible": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.pictureModalFlag) = $event)),
          title: _ctx.pictureModalTitle,
          width: 500,
          centered: ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_a_button, {
              key: "submit",
              type: "primary",
              onClick: _ctx.downloadImg
            }, {
              default: _withCtx(() => [
                _hoisted_82
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_image, { src: _ctx.pictureModalImg }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    (_ctx.pdf)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 1,
          visible: _ctx.pictureModalFlag,
          "onUpdate:visible": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.pictureModalFlag) = $event)),
          title: _ctx.pictureModalTitle,
          width: "100%",
          bodyStyle: { height: '450px' }
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_a_button, {
              key: "submit",
              type: "primary",
              onClick: _ctx.downloadImg
            }, {
              default: _withCtx(() => [
                _hoisted_83
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("iframe", {
              name: "",
              src: _ctx.pdf,
              frameborder: "0",
              style: {"width":"100%","height":"100%"}
            }, null, 8, _hoisted_84)
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    (_ctx.isDetailVisible)
      ? (_openBlock(), _createBlock(_component_sicco_detail, {
          key: 2,
          isDetailVisible: _ctx.isDetailVisible,
          onCloseDetailVisible: _ctx.closeDetail
        }, null, 8, ["isDetailVisible", "onCloseDetailVisible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.isOpenRejectModal,
      "onUpdate:visible": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.isOpenRejectModal) = $event)),
      title: "编辑内容",
      centered: "",
      onOk: _cache[53] || (_cache[53] = ($event: any) => (_ctx.isOpenRejectModal.value = false))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.saveEvent
        }, {
          default: _withCtx(() => [
            _hoisted_85
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_textarea, {
          value: _ctx.rejectContent,
          "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.rejectContent) = $event)),
          placeholder: "请输入",
          "auto-size": { minRows: 4, maxRows: 8 }
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isRejectModal,
      "onUpdate:visible": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.isRejectModal) = $event)),
      centered: "",
      closable: "",
      width: 400
    }, {
      title: _withCtx(() => [
        _hoisted_86,
        _hoisted_87
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.isRejectModal = false))
        }, {
          default: _withCtx(() => [
            _hoisted_89
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.rejectEvent
        }, {
          default: _withCtx(() => [
            _hoisted_90
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_88, " 反馈内容会填写到所选择的" + _toDisplayString(_ctx.selectedRows.length) + "条零售记录中,确认提交吗? ", 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isToastShow,
      "onUpdate:visible": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.isToastShow) = $event)),
      centered: "",
      closable: "",
      footer: null,
      width: "400px",
      bodyStyle: { display: 'flex', height: '80px', justifyContent: 'center' }
    }, {
      title: _withCtx(() => [
        _hoisted_91,
        _hoisted_92
      ]),
      default: _withCtx(() => [
        _hoisted_93
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}